import React from "react";
import { map } from "lodash";
import {
  Container,
  Bloc,
  IconContainer,
  TextContainer,
} from "./styled-components";
import Text from "../text";

const OrientationBloc = ({ options }: any) => {
  return (
    <Container>
      {map(options, ({ icon, title, description }, index) => (
        <Bloc key={index}>
          <IconContainer>{icon}</IconContainer>
          <TextContainer>
            {title && (
              <Text size="18px" lineHeight="20px" weight={700}>
                {title}
              </Text>
            )}
            {description && <div>{description}</div>}
          </TextContainer>
        </Bloc>
      ))}
    </Container>
  );
};

export default OrientationBloc;
